import { useQuery, useMutation, keepPreviousData } from '@tanstack/react-query';
import { ProvidersAPI, ILLMKeyData, IProvider } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const providersAPI = new ProvidersAPI(axios);

type IQueryKeys = {
    getLLMProviderKeys: (providerId: string) => [string, string];
};
export const QUERY_KEYS: IQueryKeys = {
    getLLMProviderKeys: (providerId) => ['provider/keys', providerId]
};

// GET LLM providers
export const useProvidersQuery = () => {
    return useQuery({
        queryKey: ['providers'],
        queryFn: async (): Promise<IProvider[]> =>
            providersAPI.getLLMProviders(),
        placeholderData: keepPreviousData
    });
};

// GET LLM provider keys
export const useProviderKeysQuery = (providerId: string) => {
    return useQuery({
        queryKey: QUERY_KEYS.getLLMProviderKeys(providerId),
        queryFn: async () => providersAPI.getLLMProviderKeys(providerId)
    });
};

// CREATE LLM key
export const useCreateKeyMutation = () => {
    return useMutation({
        mutationFn: async ({
            providerId,
            data
        }: {
            providerId: string;
            data: ILLMKeyData;
        }) => providersAPI.createLLMKey(providerId, data)
    });
};

// UPDATE LLM key
export const useUpdateKeyMutation = () => {
    return useMutation({
        mutationFn: async ({
            keyId,
            data
        }: {
            keyId: string;
            data: ILLMKeyData;
        }) => providersAPI.updateLLMKey(keyId, data)
    });
};

// DELETE LLM key
export const useDeleteKeyMutation = () => {
    return useMutation({
        mutationFn: async ({ keyId }: { keyId: string }) =>
            providersAPI.deleteLLMKey(keyId)
    });
};
